/**
 * View transform math (world feet <-> screen px), shared by phone and web.
 * `s` is px per foot, `r` the view rotation in radians, `tx`/`ty` the offset.
 */
import { bbox } from './geom';
import type { Plan, Pt } from './types';

export interface View { s: number; r: number; tx: number; ty: number }

export function w2s(v: View, p: Pt): Pt {
  const c = Math.cos(v.r), s = Math.sin(v.r);
  return { x: (p.x * c - p.y * s) * v.s + v.tx, y: (p.x * s + p.y * c) * v.s + v.ty };
}

export function s2w(v: View, p: Pt): Pt {
  const c = Math.cos(v.r), s = Math.sin(v.r);
  const x = (p.x - v.tx) / v.s, y = (p.y - v.ty) / v.s;
  return { x: x * c + y * s, y: -x * s + y * c };
}

/** Plan bounding box in world feet [x0, y0, x1, y1], or null for an empty plan. */
export function planBounds(plan: Plan): [number, number, number, number] | null {
  const pts = plan.rooms.flatMap((r) => r.corners);
  return pts.length ? bbox(pts) : null;
}

/** Nearest quarter turn (Square up the view). */
export const squareRotation = (r: number): number => Math.round(r / (Math.PI / 2)) * (Math.PI / 2);
